import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Loader2, Lock, ArrowLeft } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [emailConfirm, setEmailConfirm] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      if (isRegister) {
        if (email !== emailConfirm) {
          setError('Les emails ne correspondent pas');
          setLoading(false);
          return;
        }
        await register(email, password);
        navigate('/');
      } else {
        await login(email, password);
        navigate('/');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
      <Link to="/" className="fixed top-4 left-4 z-50">
        <button className="flex items-center gap-2 px-4 py-2 bg-black/80 hover:bg-black/90 backdrop-blur-sm rounded-full transition-colors text-white font-work font-semibold">
          <ArrowLeft className="w-5 h-5" />
          Retour
        </button>
      </Link>
      
      <Card className="bg-bg-secondary border-white/10 w-full max-w-md">
        <CardHeader>
          <div className="text-center mb-4">
            <h1 className="font-bebas text-5xl text-netflix-red mb-2">WEBEOS</h1>
            <Lock className="w-12 h-12 text-netflix-red mx-auto mb-4" />
          </div>
          <CardTitle className="text-2xl font-work text-white text-center">
            {isRegister ? 'Créer un compte' : 'Connexion'}
          </CardTitle>
          <CardDescription className="text-text-secondary font-inter text-center">
            {isRegister ? 'Rejoignez WEBEOS' : 'Connectez-vous pour continuer'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-bg-tertiary border-white/20 text-white"
              />
            </div>
            
            {isRegister && (
              <div>
                <Input
                  type="email"
                  placeholder="Confirmer l'email"
                  value={emailConfirm}
                  onChange={(e) => setEmailConfirm(e.target.value)}
                  required
                  className="bg-bg-tertiary border-white/20 text-white"
                />
              </div>
            )}
            
            <div>
              <Input
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-bg-tertiary border-white/20 text-white"
              />
            </div>

            {error && (
              <div className="p-3 bg-red-900/20 border border-red-500/50 rounded-md">
                <p className="text-red-200 text-sm">{error}</p>
              </div>
            )}

            <Button type="submit" disabled={loading} className="w-full bg-netflix-red hover:bg-netflix-red-hover py-6">
              {loading ? (
                <>
                  <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                  Chargement...
                </>
              ) : (
                isRegister ? 'S\'inscrire' : 'Se connecter'
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => { setIsRegister(!isRegister); setError(null); setEmailConfirm(''); }}
              className="text-text-secondary hover:text-white font-inter text-sm"
            >
              {isRegister ? 'Déjà un compte ? Connectez-vous' : 'Pas de compte ? Inscrivez-vous'}
            </button>
          </div>
        </CardContent>
      </Card>

    </div>
  );
}